// extracted by mini-css-extract-plugin
module.exports = {"TDA_LEFT_BOX_CONTENT":"TDA_LEFT_BOX_CONTENT--2gEvS","TDA_LEFT_BOX_CONTENT_UPLOADBOX":"TDA_LEFT_BOX_CONTENT_UPLOADBOX--GrzkY"};